import { PropsWithChildren, ReactNode } from 'react';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Heading } from '@/common/components/Heading/Heading';
import { Stack } from '@/common/components/Stack/Stack';
import { useBreakpoints } from '@/common/hooks/useBreakpoints';

export function Section({
  title,
  description,
  action,
  children,
}: TSectionProps) {
  const { md } = useBreakpoints(['md']);
  return (
    <Stack gap="section">
      {title || description ? (
        <Stack gap="xs">
          {title && (
            <Stack horizontal gap="md" justify="between" align="center">
              <Heading level={4}>{title}</Heading>
              {action && action}
            </Stack>
          )}
          {description && (
            <BodyText size={md ? 'md' : 'sm'} color="neutral30">
              {description}
            </BodyText>
          )}
        </Stack>
      ) : null}
      {children}
    </Stack>
  );
}

export type TSectionProps = {
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
} & PropsWithChildren;
